import BaseService from '@root/core/class/BaseService';

class pageWarehouseService extends BaseService {
  public postUpdateInfo = (body: Record<string, any>) => {
    return this.post(`/amendmentRequest`, body);
  };
  public getInfoAccount = () => {
    return this.get(`/info`);
  };
  public postPaypal = (body: Record<string, any>) => {
    return this.post(`/registerPaypalAccount`, body);
  };
}
export default new pageWarehouseService('/api/v1/warehouse', true);
